import { getFakeTokenHeader } from '@/utils/permissions-widget/token';

import Constants from '@/constants';

import { customPathSerializer } from './path-serializer';

import { mergeHeaders } from '@/_generated/api-clients/xp/client';
import type { CreateClientConfig } from '@/_generated/api-clients/xp/client.gen';

/**
 * ## XP API client config.
 *
 * Used by the TQ XP API client.
 */
export const createClientConfig: CreateClientConfig = config => ({
  ...config,
  baseUrl: Constants.XP_API_BASE_URL,
  headers: mergeHeaders(config?.headers, getFakeTokenHeader()),
  credentials: 'include',
  auth: async () => {
    const { getApiToken } = await import('@/utils/auth');
    return getApiToken();
  },
  pathSerializer: customPathSerializer,
});

/**
 * ## Content API client config.
 *
 * Used by the TQ Content API client.
 */
export const createClientConfigContent: CreateClientConfig = config => ({
  ...config,
  baseUrl: Constants.PATHWAY_API_URL,
  headers: mergeHeaders(config?.headers, getFakeTokenHeader()),
  credentials: 'include',
  auth: async () => {
    const { getApiToken } = await import('@/utils/auth');
    return getApiToken();
  },
});
